import React, { useCallback } from 'react';

import classNames from 'classnames';

import Button from '../Button/Button';
import CardView from '../CardView/CardView';
import Label from '../Labels/Label';
import ModalOverlay from '../ModalOverlay/ModalOverlay';

export const ConfirmationDialogPanel = ({
  title,
  children,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  confirmButtonType = 'primary',
  cancelButtonType = 'default',
  hideConfirmButton = false,
  hideCancelButton = false,
  hideCloseButton = false,
  disableConfirmationButton = false,
  onConfirm = () => {},
  onCancel = () => {},
  onClose = () => {},
}) => (
  <CardView disableFullHeight>
    <div className="flex justify-between items-center m-1">
      <Label size="2xl" bold>{title}</Label>
      {
        !hideCloseButton && (
          <Button variant="close" onClick={onClose}/>
        )
      }
    </div>
    <div className="flex justify-center items-center">
      {children}
    </div>
    <div className={classNames(
      'flex m-1',
      { 'justify-between': !hideCancelButton },
      { 'justify-end': hideCancelButton },
    )}>
      {
        !hideCancelButton && (
          <Button variant={cancelButtonType} onClick={onCancel}>
            {cancelButtonText}
          </Button>
        )
      }
      {
        !hideConfirmButton && (
          <Button disabled={disableConfirmationButton} variant={confirmButtonType} onClick={onConfirm}>
            {confirmButtonText}
          </Button>
        )
      }
    </div>
  </CardView>
)

export const ConfirmationDialog = ({
  title,
  children,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  confirmButtonType = 'primary',
  cancelButtonType = 'default',
  onConfirm = () => {},
  onCancel = () => {},
  onClose = () => {},
  hideConfirmButton = false,
  hideCloseButton = false,
  hideCancelButton = false,
  disableConfirmationButton = false,
  showDialog = false,
  onDialogToggle = () => {},
  modalAnimationKey = 'confirmation-dialog-window',
}) => {
  const handleConfirmation = useCallback((e) => {
    onConfirm(e);
  }, [onConfirm]);

  const handleCancellation = useCallback((e) => {
    onCancel(e);
    onDialogToggle(false);
  }, [onCancel, onDialogToggle])

  const handleClose = useCallback((e) => {
    onClose(e);
    onDialogToggle(false);
  }, [onClose, onDialogToggle])
  return (
    <ModalOverlay animationKey={modalAnimationKey} onModalToggle={onDialogToggle} active={showDialog} useScrollLock={false}>
      <ConfirmationDialogPanel
        title={title}
        cancelButtonText={cancelButtonText}
        confirmButtonText={confirmButtonText}
        confirmButtonType={confirmButtonType}
        cancelButtonType={cancelButtonType}
        hideConfirmButton={hideConfirmButton}
        hideCloseButton={hideCloseButton}
        hideCancelButton={hideCancelButton}
        disableConfirmationButton={disableConfirmationButton}
        onConfirm={handleConfirmation}
        onCancel={handleCancellation}
        onClose={handleClose}
      >
        {children}
      </ConfirmationDialogPanel>
    </ModalOverlay>
  )
}

export default ConfirmationDialog;
